export default "__VITE_ASSET__DEwT3E5Z__"